/* eslint-disable camelcase */
  <template >
  <div v-role="'func'">
    <br><br>
  <div>
  <div class="formPosition">
            <v-card style="margin:auto;" width="900px">
              <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
              </v-overlay>
              <template >

                  <v-card-title   style="color:white;background-color:#006699">

           <v-row>
                    <v-col sm="4" cols="12" md="4">

    </v-col>

     <v-col sm="4" cols="12" md="6">  <!--  form titlte section   {{ formTitle }}-->
  <span style="font-size:20px;"> Cadastro de Propinas</span>

     </v-col>

  </v-row>

                  </v-card-title >
                  <v-alert
                v-model="alert"
                dismissible
                :color="alerCor"
                border="left"
                elevation="2"
                colored-border
                :icon="typeIcon"
              >
                {{alertMensagem}}
              </v-alert>
              </template>

 <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >

              <v-card-text>

                <v-container  >

<div   v-if="$store.state.hasMessage" :class="$store.state.classMessage" >{{$store.state.textMessage}}</div>

                  <v-row>
                    <v-col  cols="12" md="6">
                      <v-combobox
                        v-model="cursoSelected"
                        :rules="ruleRequired"
                        item-value="idCurso"
                        item-text="descricao"
                        :items="cursos"
                        @change="loadclasse()"
                         chips
                        label="Selecione o Curso"
                      ></v-combobox>
                    </v-col>
                    <v-col  cols="12" md="6">
                      <v-combobox
                        v-model="classeSelected"
                        :rules="ruleRequired"
                        item-value="pkAnoacademico"
                        item-text="descricao"
                        :items="classesFiltered"
                         chips
                        label="Selecione a Classe"
                      ></v-combobox>
                    </v-col>
                    <v-col  cols="12" md="12">
                      <v-text-field
                        v-money="money"
                        v-model="preco"
                        label="Insira o Valor"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
              <v-col md="5"></v-col>
              <v-col md="3">
                  <v-btn    :disabled="!valid && novo"  color="success"    @click="save()">Salvar dados <v-icon>send</v-icon></v-btn>

              </v-col>
            </v-row>
                            </v-container>
              </v-card-text>

</v-form>

            </v-card>
  </div>
</div>
</div>
</template>
My CRUD
<script>

import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
import { VMoney } from 'v-money'
import utilitarios from '../../plugins/utilitarios'
const ls = require('local-storage')
// const axios = require('../plugins/axios')
export default {
  directives: { mask, money: VMoney },
  data: () => ({
    dropdowSexo: [
      { idSexo: 'M', descricao: 'Masculino' },
      { idSexo: 'F', descricao: 'Femenino' }
    ],

    progresso: false,
    alert: false,
    typeIcon: '',
    alertMensagem: '',
    alerCor: '',
    novo: false,
    valid: true,
    ano_actual: ls.get('anolectivo'),
    startDate: null,
    precos: [],
    cursos: [],
    overlay: false,
    classes: [],
    propinas: [],
    classesFiltered: [],
    classeSelected: null,
    cursoSelected: null,
    isLoading: false,
    servico: '',
    cor: '',

    money: {
      decimal: ',',
      thousands: '.',
      suffix: ' Kz',
      precision: 2,
      masked: false
    },
    searchInDb: '',
    preco: 0,
    valorFormatado: '',
    valorConvertido: '',
    dialog: false,
    idd: false, // simula autoinclemet

    y: 'top',
    text: 'mensagem nao setada.',
    //  timeout: 4000,
    ruleNumber: [
      value => !!value || 'campo obrigatório.',
      value => {
        const pattern = /^[0-9]*$/
        return pattern.test(value) || 'Invalido.'
      }
    ],
    ruleRequired: [value => !!value || 'campo obrigatorio'],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value =>
        (value || '').length <= 50 || 'O máximo número de carácters atigidos',

      value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ],
    headers: [
      {
        text: 'Curso',
        align: 'left',
        sortable: false,
        value: 'curso'
      },

      { text: 'Classe', value: 'classe' },
      { text: 'Preço', value: 'preco' },
      { text: 'data cadastro', value: 'data_' },
      { text: 'Autor', value: 'autor' }

    ],
    msg: '',
    editedIndex: -1

  }),

  computed: {

    loggedUserName () {
      return ls.get('nomeUsuario')
    },

    textMessage () {
      return this.$store.state.textMessage
    },
    classMessage () {
      return this.$store.state.classMessage
    },
    hasMessage () {
      return this.$store.state.hasMessage
    },

    ListaActividades () {
      return ls.get('lista_actividades')
    }

  },

  watch: {
    menu (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menubi (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    estudantes () {
      this.isLoading = false
      this.$store.state.isloading = false
    },
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    // check if classe has been selected otherwise send back to painel to select
     this.initializeCursos()
     this.initializeClasses()
     this.initializePrecosPropina()
  },

  methods: {
    // METHODO FOR VALIDATION
    validate () {
      if (this.$refs.form.validate()) {

      } else {
        console.log('elso foraaa')
      }
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    // END METHOD FOR VAL

    async initializeCursos () {
      try {
        this.isLoading = true
        this.cursos = await axios
          .get('/cursoFindAll')
          .then(res => res.data)

        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async initializePrecosPropina () {
      try {
        this.isLoading = true
        this.precos = await axios
          .get('/precoPropinasFindAll')
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async initializeClasses () {
      try {
        this.isLoading = true
        this.classes = await axios
          .get('/classeFindAll2')
          .then(res => res.data)

        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    loadclasse () {
      this.classesFiltered = this.classes
    },

    chamaDialogo () {
      this.dialog = true
    },

    showAlert (cor, msg, icon) {
      this.alert = true
      this.typeIcon = icon
      this.alerCor = cor
      this.alertMensagem = msg

      setTimeout(() => {
        this.alert = false
      }, 3000)
    },

    close () {
      this.dialog = false
      this.$refs.form.reset()
    },
    ObterValorFormatado (valor) {
      let formated = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'AOA' }).format(valor)
      this.valorFormatado = formated.toString().replace('AOA', '')
    },

    async save () {
      if (this.$refs.form.validate()) {
        this.overlay = true
        this.ObterValorFormatado(this.preco)
        let params =
        {
          pk_definir_precario_propina: 0,
          curso: this.cursoSelected,
          classe: this.classeSelected,
          preco: utilitarios.MoneyValueToInteger(this.preco),
          autor: ls.get('nomeUsuario'),
          valor: this.preco,
          idCurso: this.cursoSelected.idCurso
        }

        let precoExistente = this.precos.filter(p => p.fkClasse === this.classeSelected.pkAnoacademico && p.idCurso === this.cursoSelected.idCurso && p.status_definir_precario_propina === 1)
        if (!precoExistente.length) { // verifica se já foi definido o valor para este curso e classe
          try {
            let msg = await axios.post('/precoPropinaInsertOrUpdate', params).then(res => res.data)
            if(msg.affectedRows >= 1){
              utilitarios.showAlertMessage('success','Registro efectuado com sucesso.')
            }else{
               utilitarios.showAlertMessage('error','Ocorreu um erro ao tentar efectuar a operação.')
            }
          } catch (error) {
              this.overlay = false
              utilitarios.showAlertMessage('error','Ocorreu um erro ao tentar efectuar a operação.')
          }finally{this.overlay = false}
        } else {
          this.overlay = false
          utilitarios.showAlertMessage('warning','Ja foi definido o valor da mensalidade para este curso e classe.')
        }
      }
    }
  }
}
</script>
<style scoped>

.bg {
 color:green;
 background: red
}

</style>
